import React, { useEffect, useState } from 'react';
import './rush.css';
import './features.css';
import { RushNav, RushFooter, useRushReveal } from './RushChrome';
import { ProjectsTable, EditorMock, TMList, Integrations, Calendar } from './RushDashMocks';
import WaitlistForm from './WaitlistForm';

const FEATURES = [
  { id: 'projects', ix: '01', label: 'Project overview' },
  { id: 'editor', ix: '02', label: 'AI + human editor' },
  { id: 'memory', ix: '03', label: 'Memory & glossaries' },
  { id: 'integrations', ix: '04', label: 'Files & integrations' },
  { id: 'deadlines', ix: '05', label: 'Deadlines & assignment' },
  { id: 'brand-voice', ix: '06', label: 'Brand voice' },
  { id: 'automations', ix: '07', label: 'Automations' },
  { id: 'ai-quality', ix: '08', label: 'AI quality' },
  { id: 'preview', ix: '09', label: 'Preview' },
  { id: 'layout-risk', ix: '10', label: 'Layout risk' },
];

const Ic = {
  filter: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 3h12M4 8h8M6 13h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg>,
  pipe: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.6" /><circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.6" /><path d="M4 6v4a2 2 0 002 2h4" stroke="currentColor" strokeWidth="1.6" /></svg>,
  alert: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l6 11H2L8 2zM8 7v3M8 11.5v.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  bolt: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M9 2L3 9h4l-1 5 6-7H8l1-5z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg>,
  layers: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l6 3-6 3-6-3 6-3zM2 8l6 3 6-3M2 11l6 3 6-3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" /></svg>,
  brackets: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3H3v10h3M10 3h3v10h-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  ai: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 2l1.5 3.5L13 7l-3.5 1.5L8 12l-1.5-3.5L3 7l3.5-1.5L8 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" /></svg>,
  history: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.6" /><path d="M8 5v3l2 1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  lock: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.6" /><path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.6" /></svg>,
  search: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4" stroke="currentColor" strokeWidth="1.6" /><path d="M10.5 10.5L14 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  cloud: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 11a3 3 0 010-6 4 4 0 017.5-1A3 3 0 1112 12H4z" stroke="currentColor" strokeWidth="1.5" /></svg>,
  doc: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4 2h6l3 3v9H4V2z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><path d="M10 2v3h3M6 8h4M6 11h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" /></svg>,
  sync: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 6a5 5 0 018-3l2 2M13 10a5 5 0 01-8 3l-2-2M3 4v3h3M13 12V9h-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>,
  cal: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.6" /><path d="M2 6h12M5 1.5v2M11 1.5v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  users: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.6" /><path d="M1.5 13c.7-2.2 2.4-3.5 4.5-3.5s3.8 1.3 4.5 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="12" cy="5" r="1.8" stroke="currentColor" strokeWidth="1.6" /><path d="M11 9.5c1.6 0 2.8.9 3.5 2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  flow: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" /><rect x="11" y="3" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" /><rect x="1" y="10" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" /><rect x="11" y="10" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1.5" /><path d="M5 4.5h6M5 11.5h6M3 6.5v3M13 6.5v3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" /></svg>,
  sliders: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 4h6M11 4h2M3 12h2M7 12h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><circle cx="10" cy="4" r="1.6" stroke="currentColor" strokeWidth="1.6" /><circle cx="6" cy="12" r="1.6" stroke="currentColor" strokeWidth="1.6" /></svg>,
  gauge: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 12a5.5 5.5 0 1111 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /><path d="M8 12l3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" /></svg>,
  eye: <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /><circle cx="8" cy="8" r="1.8" stroke="currentColor" strokeWidth="1.6" /></svg>,
};

const Hero = () => (
  <section className="features-hero">
    <div className="hero-mesh"></div>
    <div className="rs-container hero-anim" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <span className="hero-eyebrow"><span className="dot"></span>Ten features. One dashboard.</span>
      <h1 className="features-h1">Built for the actual work<br />of localization.</h1>
      <p className="features-lead">Every feature in Rush Studio earned its place by replacing something localization teams already used to do — a spreadsheet, a shared inbox, a CAT tool, a folder of files. Here's what each one does, in detail.</p>
      <div className="features-hero-cta">
        <a className="btn btn-accent btn-lg" href="#editor">See the editor →</a>
        <a className="btn btn-ghost btn-lg" href="#brand-voice">What sets us apart</a>
      </div>
    </div>
  </section>
);

const StickySubNav = () => {
  const [active, setActive] = useState('projects');
  useEffect(() => {
    const sections = FEATURES.map((f) => document.getElementById(f.id)).filter(Boolean);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  return (
    <div className="feat-subnav">
      <div className="rs-container">
        <div className="feat-subnav-inner">
          {FEATURES.map((f) => (
            <a key={f.id} href={`#${f.id}`} className={`feat-subnav-item ${active === f.id ? 'active' : ''}`}>
              <span className="feat-subnav-ix">{f.ix}</span>
              <span>{f.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const FeatureSection = ({ id, ix, eyebrow, title, intro, subFeatures, replaces, visual, reverse }) => (
  <section className="feat-section" id={id}>
    <div className="rs-container">
      <div className={`feat-grid ${reverse ? 'reverse' : ''}`}>
        <div className="feat-copy reveal">
          <div className="feat-ix">{ix}</div>
          <div className="eyebrow">{eyebrow}</div>
          <h2 className="feat-title">{title}</h2>
          <p className="feat-intro">{intro}</p>
          <div className="feat-sublist">
            {subFeatures.map((sf) => (
              <div className="feat-sub" key={sf.title}>
                <div className="feat-sub-icon">{sf.icon}</div>
                <div>
                  <div className="feat-sub-title">{sf.title}</div>
                  <div className="feat-sub-desc">{sf.desc}</div>
                </div>
              </div>
            ))}
          </div>
          {replaces && (
            <div className="feat-replaces">
              <span className="feat-replaces-label">Replaces</span>
              <span className="feat-replaces-tags">
                {replaces.map((r) => <span className="feat-replace-tag" key={r}>{r}</span>)}
              </span>
            </div>
          )}
        </div>
        <div className="feat-visual reveal reveal-scale">{visual}</div>
      </div>
    </div>
  </section>
);

const MockFrame = ({ url, children }) => (
  <div className="mock-frame">
    <div className="mock-chrome">
      <span className="dots"><span /><span /><span /></span>
      <span className="mock-url">{url}</span>
    </div>
    <div style={{ padding: '16px 18px 18px' }}>{children}</div>
  </div>
);

const ProjectsMockup = () => (
  <MockFrame url="rush.studio / projects">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
      <div>
        <div style={{ fontSize: 16, fontWeight: 600 }}>Active projects · 24</div>
        <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>3 due this week · 1 at risk</div>
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <span className="filter-chip active">All</span>
        <span className="filter-chip">My team</span>
        <span className="filter-chip">This week</span>
      </div>
    </div>
    <ProjectsTable />
  </MockFrame>
);

const EditorMockup = () => (
  <MockFrame url="rush.studio / editor">
    <EditorMock />
    <div style={{ marginTop: 14, fontSize: 11, color: 'var(--ink-4)', display: 'flex', justifyContent: 'space-between' }}>
      <span>↑↓ navigate · ⌘↵ accept · ⌘. open glossary</span>
      <span>248 segments · 12 in review · 4 flagged</span>
    </div>
  </MockFrame>
);

const MemoryMockup = () => (
  <MockFrame url="rush.studio / memory">
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600 }}>Memories</div>
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>3 active · domain overlays take priority</div>
      </div>
      <span className="filter-chip">+ New memory</span>
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 14 }}>
      {[
        { flag: 'DE', name: 'EN → DE — master', sub: 'EN → DE · 42,850', prio: 'priority 200', tone: null, on: false },
        { flag: '★', name: 'Brand voice', sub: 'Multi · 6 pairs · write-back on', prio: 'priority 50', tone: 'var(--accent)', on: true },
        { flag: '§', name: 'Legal & compliance', sub: 'Multi · 4 pairs · read-only', prio: 'priority 60', tone: 'var(--indigo)', on: false },
      ].map((m) => (
        <div key={m.name} style={{
          display: 'flex', alignItems: 'center', gap: 9, padding: '7px 9px', borderRadius: 8,
          border: '1px solid ' + (m.on ? 'color-mix(in oklab, var(--accent) 40%, var(--line))' : 'var(--line)'),
          background: m.on ? 'color-mix(in oklab, var(--accent) 6%, var(--bg-card))' : 'var(--bg-card)',
        }}>
          <span style={{
            width: 22, height: 22, borderRadius: 6, display: 'grid', placeItems: 'center',
            background: m.tone || 'var(--bg-soft)', color: m.tone ? '#fff' : 'var(--ink-3)',
            fontSize: 10, fontWeight: 700,
          }}>{m.flag}</span>
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink)' }}>{m.name}</span>
            <span style={{ fontSize: 10.5, color: 'var(--ink-4)' }}>{m.sub}</span>
          </div>
          <span style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--ink-4)', background: 'var(--bg-soft)', padding: '2px 7px', borderRadius: 999 }}>{m.prio}</span>
        </div>
      ))}
    </div>
    <TMList />
    <div style={{ marginTop: 16, padding: 12, background: 'var(--bg-soft)', borderRadius: 10, fontSize: 12 }}>
      <div style={{ fontWeight: 600, fontSize: 11, color: 'var(--ink-4)', letterSpacing: '0.04em', marginBottom: 8 }}>GLOSSARY TERMS</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {[['workspace', 'Arbeitsbereich'], ['dashboard', 'Dashboard'], ['translation', 'Übersetzung'], ['review', 'Prüfung']].map(([a, b]) => (
          <span key={a} style={{ background: 'var(--bg-card)', border: '1px solid var(--line)', borderRadius: 6, padding: '4px 8px', fontSize: 11 }}>
            <span style={{ color: 'var(--ink-3)' }}>{a}</span>
            <span style={{ color: 'var(--ink-4)', margin: '0 6px' }}>→</span>
            <span style={{ color: 'var(--accent)', fontWeight: 600 }}>{b}</span>
          </span>
        ))}
      </div>
    </div>
  </MockFrame>
);

const FilesMockup = () => (
  <MockFrame url="rush.studio / files">
    <div style={{ border: '2px dashed var(--line-2)', borderRadius: 12, padding: 24, textAlign: 'center', marginBottom: 18 }}>
      <div style={{ fontSize: 28, marginBottom: 6 }}>↓</div>
      <div style={{ fontWeight: 600, fontSize: 14 }}>Drop files here</div>
      <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 4 }}>or paste a URL · we'll figure out the format</div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 4, marginTop: 12, flexWrap: 'wrap' }}>
        {['DOCX', 'IDML', 'XLIFF', 'JSON', 'MD', 'PPTX', 'HTML', 'PO'].map((t) => (
          <span key={t} style={{ fontSize: 10, padding: '2px 8px', border: '1px solid var(--line)', borderRadius: 6, color: 'var(--ink-3)', background: 'var(--bg-card)' }}>{t}</span>
        ))}
      </div>
    </div>
    <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.04em', color: 'var(--ink-4)', marginBottom: 8 }}>CONNECTED SOURCES</div>
    <Integrations />
  </MockFrame>
);

const DeadlinesMockup = () => (
  <MockFrame url="rush.studio / calendar">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600 }}>This week · 11 deadlines</div>
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>Apr 28 – May 04 · 1 at risk</div>
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <span className="filter-chip">Week</span>
        <span className="filter-chip active">Month</span>
      </div>
    </div>
    <Calendar />
    <div style={{ marginTop: 14, padding: '10px 12px', background: 'color-mix(in oklab, var(--accent) 8%, transparent)', borderRadius: 8, border: '1px solid color-mix(in oklab, var(--accent) 25%, transparent)', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12 }}>
      <span style={{ color: 'var(--accent)', fontSize: 14 }}>⚠</span>
      <span><b>Q4 Update — JA</b> is at risk. Tomorrow's deadline, 22% complete.</span>
    </div>
  </MockFrame>
);

const BrandVoiceMockup = () => (
  <div className="mock-frame">
    <div className="mock-chrome"><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-title">Brand voice · DE</span></div>
    <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
        {[['Formality', 72], ['Warmth', 60], ['Playfulness', 28]].map(([l, v]) => (
          <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11.5 }}>
            <span style={{ width: 74, color: 'var(--ink-3)' }}>{l}</span>
            <span style={{ flex: 1, height: 5, background: 'var(--bg-soft)', borderRadius: 999 }}><span style={{ display: 'block', height: '100%', width: v + '%', background: 'var(--accent)', borderRadius: 999 }}></span></span>
          </div>
        ))}
      </div>
      <div style={{ border: '1px solid var(--line)', borderRadius: 9, padding: 10, background: 'var(--bg-soft)' }}>
        <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.04em', color: 'var(--ink-4)', textTransform: 'uppercase' }}>Generic engine</div>
        <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 3 }}>Willkommen zurück! Bereit weiterzumachen?</div>
      </div>
      <div style={{ border: '1px solid color-mix(in oklab, var(--accent) 35%, var(--line))', borderRadius: 9, padding: 10, background: 'color-mix(in oklab, var(--accent) 5%, var(--bg-card))' }}>
        <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.04em', color: 'var(--accent)', textTransform: 'uppercase' }}>On-brand · Rush AI</div>
        <div style={{ fontSize: 12.5, color: 'var(--ink)', fontWeight: 500, marginTop: 3 }}>Schön, dass Sie wieder da sind.</div>
        <div style={{ display: 'flex', gap: 5, marginTop: 8 }}>
          {['Sie · formal', 'Warm tone'].map((c) => <span key={c} style={{ fontSize: 9.5, fontWeight: 600, color: 'var(--accent-2)', background: 'var(--accent-soft)', padding: '2px 7px', borderRadius: 999 }}>{c}</span>)}
        </div>
      </div>
    </div>
  </div>
);

const AutomationsMockup = () => (
  <div className="mock-frame">
    <div className="mock-chrome"><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-title">Localize on every PR · Active</span></div>
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
      {[
        ['WHEN', 'Pull request opened', 'acme/strings', 'var(--accent-soft)', 'var(--accent)'],
        ['THEN', 'Translate', 'into DE · FR · JA · ES', 'var(--bg-soft)', 'var(--indigo)'],
        ['THEN', 'Open translation PR', 'as a follow-up PR', 'var(--bg-soft)', 'var(--indigo)'],
      ].map(([k, t, s, bg, fg], i) => (
        <React.Fragment key={i}>
          {i > 0 && <div style={{ width: 1, height: 12, background: 'var(--line-2)', marginLeft: 18 }}></div>}
          <div style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '10px 12px', borderRadius: 10, background: bg, border: '1px solid var(--line)' }}>
            <span style={{ width: 30, height: 30, borderRadius: 8, background: 'var(--bg-card)', color: fg, display: 'grid', placeItems: 'center' }}>{i === 0 ? Ic.bolt : Ic.flow}</span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: '.06em', color: 'var(--ink-4)' }}>{k}</span>
              <b style={{ fontSize: 12.5 }}>{t}</b>
              <span style={{ fontSize: 11, color: 'var(--ink-4)' }}>{s}</span>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
);

const AIQualityMockup = () => (
  <div className="mock-frame">
    <div className="mock-chrome"><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-title">AI quality · 248 segments</span></div>
    <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', gap: 3, height: 12 }}>
        <span style={{ width: '62%', background: 'var(--green)', borderRadius: '6px 0 0 6px' }}></span>
        <span style={{ width: '22%', background: 'var(--yellow)' }}></span>
        <span style={{ width: '16%', background: '#d2604f', borderRadius: '0 6px 6px 0' }}></span>
      </div>
      <div style={{ display: 'flex', gap: 14, fontSize: 11, color: 'var(--ink-3)' }}>
        <span>● Safe 154</span><span>● Review 56</span><span>● Risk 38</span>
      </div>
      <div style={{ border: '1px solid var(--line)', borderLeft: '3px solid #d2604f', borderRadius: 9, padding: 11, background: 'var(--bg-soft)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: '#d2604f' }}>63</span>
          <span style={{ fontSize: 9.5, fontWeight: 700, color: '#b53e3e', background: '#fbe1e1', padding: '1px 7px', borderRadius: 999 }}>Terminology</span>
          <span style={{ fontSize: 9.5, fontWeight: 700, color: '#a87a14', background: 'var(--yellow-soft)', padding: '1px 7px', borderRadius: 999 }}>Fluency</span>
        </div>
        <div style={{ fontSize: 12, color: 'var(--ink)' }}>"sperren" should be the locked term "sichern".</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11.5, color: 'var(--ink-3)' }}>
        <span style={{ background: 'var(--green-soft)', color: 'var(--green)', fontWeight: 700, padding: '4px 10px', borderRadius: 8 }}>✓ Auto-approve 154 safe</span>
      </div>
    </div>
  </div>
);

const PreviewMockup = () => (
  <div className="mock-frame">
    <div className="mock-chrome"><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-title">In-context · DE · 1 issue</span></div>
    <div style={{ padding: 16 }}>
      <div style={{ border: '1px solid var(--line)', borderRadius: 10, overflow: 'hidden', background: 'var(--bg-card)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderBottom: '1px solid var(--line)' }}>
          <b style={{ fontSize: 12 }}>Acme</b>
          <span style={{ fontSize: 11, color: 'var(--ink-4)', marginLeft: 'auto' }}>Funktionen · Preise</span>
        </div>
        <div style={{ padding: '20px 14px', textAlign: 'center' }}>
          <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: '-.02em', marginBottom: 12 }}>Veröffentlichen Sie in jeder Sprache.</div>
          <span style={{ display: 'inline-block', maxWidth: 150, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 12, fontWeight: 600, color: '#fff', background: 'var(--accent)', padding: '8px 16px', borderRadius: 8, outline: '2px solid #e0654f', outlineOffset: 2 }}>Kostenlose Testversion starten</span>
          <div style={{ fontSize: 10.5, color: '#d2604f', fontWeight: 600, marginTop: 10, display: 'inline-flex', alignItems: 'center', gap: 5 }}>{Ic.alert} Button text overflows by 34px</div>
        </div>
      </div>
    </div>
  </div>
);

const LayoutRiskMockup = () => {
  const RISK = '#d2604f';
  const TIGHT = '#e0a92a';
  const frames = [
    [8, 8, 84, 15, 'ok', 55], [8, 28, 84, 18, 'ok', 64],
    [8, 50, 52, 30, 'ok', 70], [64, 50, 28, 30, 'ok', 28],
    [8, 84, 50, 9, 'tight', 92], [64, 84, 28, 9, 'over', 100],
  ];
  const color = (s) => (s === 'over' ? RISK : s === 'tight' ? TIGHT : 'var(--green)');
  return (
    <div className="mock-frame">
      <div className="mock-chrome"><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-dot"></span><span className="mc-title">Layout risk · DE · pre-flight</span></div>
      <div style={{ padding: 16, display: 'flex', gap: 14 }}>
        <div style={{ position: 'relative', width: 200, height: 264, background: '#fffdf8', border: '1px solid rgba(0,0,0,0.12)', borderRadius: 3, boxShadow: '0 8px 22px rgba(20,17,12,0.12)', flex: '0 0 auto' }}>
          {frames.map(([l, t, w, h, s, fill], i) => (
            <div key={i} style={{ position: 'absolute', left: `${l}%`, top: `${t}%`, width: `${w}%`, height: `${h}%`, border: `1.5px solid ${color(s)}`, borderRadius: 2, overflow: 'hidden', background: 'var(--bg-card)' }}>
              <span style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: `${Math.min(fill, 100)}%`, background: `color-mix(in oklab, ${color(s)} ${s === 'ok' ? 22 : 42}%, transparent)` }} />
              {s === 'over' && <span style={{ position: 'absolute', left: 0, right: 0, top: 0, height: '34%', background: 'repeating-linear-gradient(45deg, rgba(210,96,79,.55) 0 3px, rgba(210,96,79,.18) 3px 6px)' }} />}
            </div>
          ))}
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 700 }}>German runs ≈ +35%</div>
          <div style={{ border: '1px solid var(--line)', borderLeft: `3px solid ${RISK}`, borderRadius: 8, padding: '8px 10px', background: 'var(--bg-soft)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ fontSize: 11.5, fontWeight: 650 }}>CTA button</span><span style={{ marginLeft: 'auto', fontSize: 9.5, fontWeight: 700, color: RISK, background: '#fbe1e1', padding: '1px 7px', borderRadius: 999 }}>won't fit</span></div>
            <div style={{ fontSize: 10.5, color: 'var(--ink-4)', marginTop: 3 }}>≈ 28 chars predicted · 24 fit</div>
          </div>
          <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--accent)', background: 'var(--accent-soft)', padding: '6px 10px', borderRadius: 8, alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', gap: 5 }}>{Ic.bolt} Auto-fit → “Zur Kollektion”</span>
        </div>
      </div>
    </div>
  );
};

const BeforeAfter = () => (
  <section className="section">
    <div className="rs-container">
      <div className="section-head reveal">
        <div className="eyebrow">The whole stack, replaced</div>
        <h2>Five features. Four fewer tools.</h2>
        <p className="section-lead">Most localization teams stitch together a spreadsheet, an inbox, a CAT tool, a folder, and a calendar. Rush Studio collapses all five into one.</p>
      </div>
      <div className="ba-grid reveal">
        <div className="ba-card before">
          <div className="ba-head">
            <div className="ba-label">Before Rush Studio</div>
            <div className="ba-sub">5 tools, 0 source of truth</div>
          </div>
          <ul className="ba-list">
            <li><span className="ba-icon ba-icon-bad">✕</span> Spreadsheet for project tracking</li>
            <li><span className="ba-icon ba-icon-bad">✕</span> Email threads for handoffs</li>
            <li><span className="ba-icon ba-icon-bad">✕</span> Separate CAT tool for translation</li>
            <li><span className="ba-icon ba-icon-bad">✕</span> Shared drive of "final_v3" files</li>
            <li><span className="ba-icon ba-icon-bad">✕</span> Calendar app for deadlines</li>
            <li><span className="ba-icon ba-icon-bad">✕</span> Slack channel for review comments</li>
          </ul>
        </div>
        <div className="ba-card after">
          <div className="ba-head">
            <div className="ba-label">With Rush Studio</div>
            <div className="ba-sub">One dashboard, one source of truth</div>
          </div>
          <ul className="ba-list">
            <li><span className="ba-icon ba-icon-good">✓</span> Project pipeline, every status at a glance</li>
            <li><span className="ba-icon ba-icon-good">✓</span> Inline comments where the work happens</li>
            <li><span className="ba-icon ba-icon-good">✓</span> AI + human editor with memory built-in</li>
            <li><span className="ba-icon ba-icon-good">✓</span> Files synced both ways, formatting intact</li>
            <li><span className="ba-icon ba-icon-good">✓</span> Smart deadlines with risk alerts</li>
            <li><span className="ba-icon ba-icon-good">✓</span> Reviews threaded to the segment</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

const FinalCTA = () => (
  <section className="section">
    <div className="rs-container">
      <div className="final-cta reveal reveal-scale">
        <h2>Ready to see it in your own dashboard?</h2>
        <p>Join the waitlist for early-access pricing and a 1:1 onboarding call.</p>
        <WaitlistForm source="features-final" />
      </div>
    </div>
  </section>
);

const RushFeaturesPage = () => {
  useRushReveal();
  return (
    <div className="rs">
      <RushNav active="features" />
      <Hero />
      <StickySubNav />

      <FeatureSection
        id="projects" ix="01" eyebrow="Project overview"
        title="See every translation. At a glance."
        intro="The dashboard you open first in the morning. Every project, every language pair, every owner, every deadline — sortable, filterable, and color-coded by status. Spot the at-risk delivery before your client emails about it."
        subFeatures={[
          { icon: Ic.filter, title: 'Smart filters', desc: 'Slice by language, client, owner, or due date. Save filtered views as your default.' },
          { icon: Ic.pipe, title: 'Pipeline view', desc: 'Track segments as they move through Draft → Translate → Review → Approve → Deliver.' },
          { icon: Ic.alert, title: 'Risk alerts', desc: 'Auto-flag projects falling behind their deadline. Slack + email pings, no surprises.' },
        ]}
        replaces={['spreadsheets', 'PM tools', 'status meetings']}
        visual={<ProjectsMockup />}
      />

      <FeatureSection
        id="editor" ix="02" eyebrow="AI + human editor"
        title="An editor your reviewers will actually open."
        intro="Side-by-side source and target. AI drafts in the first pass, humans polish in the second. Translation memory, glossary terms, and inline comments all live in the same view — no tab-switching, no copy-paste."
        reverse
        subFeatures={[
          { icon: Ic.ai, title: 'AI drafts in seconds', desc: 'Machine translation seeded from your TM and glossaries — not a generic engine.' },
          { icon: Ic.brackets, title: 'Formatting preserved', desc: 'Brackets, bold, code, footnotes, variables round-trip cleanly to export.' },
          { icon: Ic.history, title: 'Full version history', desc: 'Every segment edit is tracked. Roll back per-segment or per-project. Audit-friendly.' },
        ]}
        replaces={['Phrase / Trados / Memsource', 'Google Translate', 'review-by-email']}
        visual={<EditorMockup />}
      />

      <FeatureSection
        id="memory" ix="03" eyebrow="Memory & glossaries"
        title="Translate it once. Reuse it forever."
        intro="Approved phrasing becomes searchable, scorable, and reusable across every future project. Glossaries lock brand voice and terminology per client. The next project starts 40% done — and stays consistent."
        subFeatures={[
          { icon: Ic.layers, title: 'Fuzzy + exact matches', desc: '70/85/95/100% match scoring. One-click insert. Memory grows automatically.' },
          { icon: Ic.flow, title: 'Scoped memories with priority', desc: 'Spin up language masters or domain overlays (brand voice, legal). Each one decides whether it leverages-only or writes back — and where it sits in lookup order.' },
          { icon: Ic.lock, title: 'Per-client glossaries', desc: 'Enforce brand terms at the segment. Do-not-translate lists. Tone rules.' },
          { icon: Ic.search, title: 'Searchable archive', desc: "Find any sentence you've ever translated, in any language, in two keystrokes." },
        ]}
        replaces={['spreadsheet glossaries', 'ad-hoc term lookups', 'inconsistent voice']}
        visual={<MemoryMockup />}
      />

      <FeatureSection
        id="integrations" ix="04" eyebrow="Files & integrations"
        title="The format you upload is the format you ship."
        intro="DOCX, IDML, XLIFF, JSON, MD, PPTX, HTML, PO — round-tripped with formatting intact. Pull straight from Drive, Dropbox, OneDrive, GitHub, Figma. Push deliverables back where they came from."
        reverse
        subFeatures={[
          { icon: Ic.doc, title: 'Eight file formats', desc: 'Including IDML, the layout-preserving import that designers actually care about.' },
          { icon: Ic.cloud, title: 'Six cloud sources', desc: 'Drive, Dropbox, OneDrive, Box, GitHub, Figma. OAuth in under 30 seconds.' },
          { icon: Ic.sync, title: 'Two-way sync', desc: 'Change the source after kickoff? We notice, flag the diff, and re-translate only what changed.' },
        ]}
        replaces={['manual file shuffling', '"final_v3_FINAL.docx"', 'format-mangling exports']}
        visual={<FilesMockup />}
      />

      <FeatureSection
        id="deadlines" ix="05" eyebrow="Deadlines & assignment"
        title="Nothing slips. Nothing surprises."
        intro="Assign translators and reviewers per language pair. Auto-handoff at each stage. Smart deadline tracking with slip alerts — so you find out a project is at risk while you can still fix it."
        subFeatures={[
          { icon: Ic.users, title: 'Per-pair assignment', desc: 'Mira on EN→DE, Tomás on EN→FR. Each gets their own queue, you see the whole board.' },
          { icon: Ic.flow, title: 'Stage automation', desc: 'When a translator marks done, the reviewer is notified. When approved, the deliverable exports.' },
          { icon: Ic.cal, title: 'SLA tracking', desc: 'Set client SLAs once. See in real time which projects are on track, behind, or at risk.' },
        ]}
        replaces={['calendar invites', 'PM check-ins', '"any updates?" emails']}
        visual={<DeadlinesMockup />}
      />

      <FeatureSection
        id="brand-voice" ix="06" eyebrow="Brand voice"
        title="Your brand, in every language."
        intro="Most tools treat brand voice as a flat term list. Rush Studio makes it a living profile — tone, formality, and forbidden phrasings the AI actually follows — and lets you preview the voice on real copy before a single word ships."
        reverse
        subFeatures={[
          { icon: Ic.sliders, title: 'Tone & form of address', desc: 'Dial in formality, warmth, and energy; pick Sie/du, vous/tu per language.' },
          { icon: Ic.lock, title: 'Do-not-translate & forbidden terms', desc: 'Lock product names verbatim; ban off-brand wording with the reason attached.' },
          { icon: Ic.ai, title: 'Try the voice, live', desc: 'See generic MT vs your on-brand output side by side, instantly.' },
          { icon: Ic.layers, title: 'Per-language profiles', desc: "Train the model with on-brand example pairs — show, don't tell." },
        ]}
        replaces={['Style guides buried in Google Docs', 'Endless reviewer back-and-forth']}
        visual={<BrandVoiceMockup />}
      />

      <FeatureSection
        id="automations" ix="07" eyebrow="Automations"
        title="Localization that runs itself."
        intro="25+ triggers wired to your real workspace — workflow events, project lifecycle, quality slips, schedules, and every connected source. Conditions adapt to the trigger you pick. Actions route to your real team, real glossaries, real projects."
        subFeatures={[
          { icon: Ic.bolt, title: 'Workflow & quality triggers', desc: 'Segment approved or rejected, status changed, TM match drops, glossary slip, source drift, AI quality dips — fire on the moments that matter.' },
          { icon: Ic.flow, title: 'Trigger-aware conditions', desc: 'Filter by target language, project, client, assignee, urgency, word count. Switch triggers and the IF picker swaps in what makes sense.' },
          { icon: Ic.layers, title: 'Recipes + Default linguist', desc: "Nine templates including 'Catch glossary slips' and 'Re-check on source drift'. Set a default linguist per language on People — rules auto-resolve to that person." },
          { icon: Ic.history, title: 'Runs, audit & re-run', desc: 'Every run logged with success rate and duration. Re-run a failed run from the drawer once the cause is fixed.' },
        ]}
        replaces={['Manual triage', '"Did anyone translate this?" threads', 'Hand-checking glossary slips']}
        visual={<AutomationsMockup />}
      />

      <FeatureSection
        id="ai-quality" ix="08" eyebrow="AI quality"
        title="Trust the AI — verifiably."
        intro="Every draft is scored for adequacy, fluency, and risk before a human ever looks. Auto-approve what's provably safe, and send only the segments that genuinely need a person to your team — with the reasoning attached."
        reverse
        subFeatures={[
          { icon: Ic.gauge, title: 'Quality estimate', desc: "A per-segment score (MTQE) so you know what's solid before review." },
          { icon: Ic.alert, title: 'Risk flags', desc: 'Terminology, tag, length, and fluency issues surfaced and color-coded by severity.' },
          { icon: Ic.bolt, title: 'Auto-approve threshold', desc: 'Set the confidence bar; clear the safe segments in one click.' },
          { icon: Ic.search, title: 'Why this score', desc: 'Plain-language reasoning on every flag — no black box.' },
        ]}
        replaces={['Reviewing every single segment', 'Guessing which MT to trust']}
        visual={<AIQualityMockup />}
      />

      <FeatureSection
        id="preview" ix="09" eyebrow="In-context preview"
        title="See it before you ship it."
        intro="Translations rendered in the actual UI — web, mobile, and email — so you catch the #1 localization embarrassment (broken layouts) before launch. Rush Studio measures every string live and flags anything that overflows or clips."
        subFeatures={[
          { icon: Ic.eye, title: 'Real UI rendering', desc: 'Your copy in a real page, not an abstract string table.' },
          { icon: Ic.alert, title: 'Live overflow detection', desc: 'Every string measured on render; overflows outlined in red with the px over.' },
          { icon: Ic.doc, title: 'Device & email views', desc: 'Switch between web, mobile, and email to catch the tightest containers.' },
          { icon: Ic.ai, title: 'Fix in place', desc: 'Shorten a string and watch the warning clear in real time.' },
        ]}
        replaces={['Shipping and praying', 'Screenshots in review threads']}
        visual={<PreviewMockup />}
      />

      <FeatureSection
        id="layout-risk" ix="10" eyebrow="Pre-flight layout risk"
        title="Catch the overflow before you translate."
        intro="German runs ~35% longer than English. Rush pseudo-translates every text frame at each language's expansion rate and predicts which ones break — reading the real geometry from your IDML, DOCX, PPTX, and XLSX. Then Auto-fit drafts a translation sized to the frame, glossary terms kept."
        reverse
        subFeatures={[
          { icon: Ic.alert, title: 'Per-frame prediction', desc: 'Fits / tight / won’t-fit on every frame, at each target language, before a word is translated.' },
          { icon: Ic.layers, title: 'Reads real geometry', desc: 'Frame bounds, point size, and leading parsed from the source file — drawn on a true-to-layout map.' },
          { icon: Ic.gauge, title: 'Learned expansion', desc: 'Industry factors to start, sharpened to your team’s own measured ratios over time.' },
          { icon: Ic.bolt, title: 'AI Auto-fit', desc: 'One click drafts a translation constrained to the space — and you Apply or Discard.' },
        ]}
        replaces={['Printer proofs', 'Post-translation layout bug reports']}
        visual={<LayoutRiskMockup />}
      />

      <BeforeAfter />
      <FinalCTA />
      <RushFooter />
    </div>
  );
};

export default RushFeaturesPage;
